import React from "react";
import {
    useReadExchangeType1SelectBox,
    useReadExchangeType2SelectBox,
    useReadExchangeType3SelectBox,
    useReadIndustrySelectBox,
    useReadOrderTypeSelectBox,
} from "../hooks";
import { SearchAccountType } from "../interface";
import { useModal } from "../../../../../hooks";
import { SearchSystemUserInner } from "../../../../../components/common/modal/inner/SearchSystemUserInner";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import useReadVatSelectBox from "../hooks/useReadVatSelectBox";
import useReadApplicationSelectBox from "../hooks/useReadApplicationSelectBox";
import { SearchContactsInner } from "../../../../../components/common/modal/inner/SearchContactsInner";
import SearchAddressInner from "../../../../../components/common/modal/inner/SearchAddressInner";
import { useReadWonUnitSelectBox } from "../hooks/useReadWonUnitSelectBox";
import { useReadExchangeRateUnitSelectBoxApi } from "../hooks/useReadExchangeRateUnitSelectBox";
import { SearchErpInner } from "../../../../../components/common/modal/inner/SearchErpInner";
import { useUser } from "../../../../../util/userContext/UserContext";

type Props = {
    data: SearchAccountType | null | undefined;
    mode: string;
    register: UseFormRegister<SearchAccountType>;
    watchShipmentInfo: SearchAccountType;
    setValue: UseFormSetValue<SearchAccountType>;
};

/**
 * 출하정보 탭
 * @param props
 * @returns
 */
export const ShippingInformationTab = ({
    data,
    watchShipmentInfo,
    setValue,
    mode,
    register,
}: Props) => {
    const { user } = useUser();
    
    const { data: exchangeTypeSelect1 } = useReadExchangeType1SelectBox();
    const { data: exchangeTypeSelect2 } = useReadExchangeType2SelectBox();
    const { data: exchangeTypeSelect3 } = useReadExchangeType3SelectBox();
    const { data: exchangeRateUnitSelect } = useReadExchangeRateUnitSelectBoxApi();
    const { data: wonUnitSelect } = useReadWonUnitSelectBox();
    const { data: orderTypeSelect } = useReadOrderTypeSelectBox();
    const { data: industrySelect } = useReadIndustrySelectBox();
    const { data: vatSelect } = useReadVatSelectBox();
    const { data: applicationSelect } = useReadApplicationSelectBox();

    const { handleModal, resetModal } = useModal();

    return (
        <div className="content_wrap">
            <h5 className="subheading mt-0">출하정보</h5>
            <div className="table_scroll mb-0">
                <table className="table table-bordered my_table table_detail">
                    {mode === "R" ? (
                        // ===== 조회 화면 =====
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>담당자</th>
                                <td style={{ width: "33.34%" }}>
                                    {data?.contactPersonName ?? ""}
                                </td>
                                <th style={{ width: "16.66%" }}>
                                    수주유형 <span className="required">*</span>
                                </th>
                                <td>{data?.orderTypeName ?? ""}</td>
                            </tr>
                            <tr>
                                <th>
                                    납품처 <span className="required">*</span>
                                </th>
                                <td>{data?.deliveryPlaceName ?? ""}</td>
                                <th>산업구분</th>
                                <td>{data?.industryName ?? ""}</td>
                            </tr>
                            <tr>
                                <th>
                                    매출처 <span className="required">*</span>
                                </th>
                                <td>{data?.salesPlaceName ?? ""}</td>
                                <th>Application</th>
                                <td>{data?.applicationName ?? ""}</td>
                            </tr>
                            <tr>
                                <th>세금계산서 담당자</th>
                                <td>{data?.taxChargeName}</td>
                                <th>Vat 구분 <span className="required">*</span></th>
                                <td>{data?.vatTypeName ?? ""}</td>
                            </tr>
                            <tr>
                                <th>환율 기준일</th>
                                <td className="p-4px">
                                    <select className="form-select" value={data?.exchangeRateCondition1} disabled>
                                        <option value={undefined} hidden>-</option>
                                        {exchangeTypeSelect1?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                                <th>환율 지정 조건</th>
                                {/*<td>*/}
                                {/*<div className="d-flex align-items-center">*/}
                                {/*    {exchangeTypeSelect1?.map((item) => {*/}
                                {/*        if (item?.id === data?.exchangeRateCondition1) {*/}
                                {/*            return <span>{item?.name}</span>;*/}
                                {/*        }*/}
                                {/*    })}*/}
                                {/*    {exchangeTypeSelect2?.map((item) => {*/}
                                {/*        if (item?.id === data?.exchangeRateCondition2) {*/}
                                {/*            return <span className="ms-3">{item?.name}</span>;*/}
                                {/*        }*/}
                                {/*    })}*/}
                                {/*    {exchangeTypeSelect3?.map((item) => {*/}
                                {/*        if (item?.id === data?.exchangeRateCondition3) {*/}
                                {/*            return <span className="ms-3">{item?.name}</span>;*/}
                                {/*        }*/}
                                {/*    })}*/}
                                {/*</div>*/}
                                <td className="p-4px">
                                    <div className="d-flex align-items-center">
                                        <select className="form-select" value={data?.exchangeRateCondition2} disabled>
                                            <option value={undefined} hidden>-</option>
                                            {exchangeTypeSelect2?.map((item) => {
                                                return <option value={item.id}>{item?.name}</option>;
                                            })}
                                        </select>
                                        <select className="form-select ms-1" value={data?.exchangeRateCondition3} disabled>
                                            <option value={undefined} hidden>-</option>
                                            {exchangeTypeSelect3?.map((item) => {
                                                return <option value={item.id}>{item?.name}</option>;
                                            })}
                                        </select>
                                        <select className="form-select ms-1" value={data?.exchangeRateUnit} disabled>
                                            <option value={undefined} hidden>-</option>
                                            {exchangeRateUnitSelect?.map((item) => {
                                                return <option value={item.id}>{item?.name}</option>;
                                            })}
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>원화 단가 단위</th>
                                <td className="p-4px">
                                    <select className="form-select" value={data?.wonUnit} disabled>
                                        <option value={undefined} hidden>-</option>
                                        {wonUnitSelect?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                                <th>마감 구분</th>
                                <td>{data?.endType === "1"
                                    ? "일반"
                                    : data?.endType === "2"
                                        ? "월마감"
                                        : data?.endType === "3" ? '역발행' : ""}</td>
                            </tr>
                            <tr>
                                <th>기타사항(거래명세서 비고)</th>
                                <td colSpan={3}>
                                    {data?.newTxtNote}
                                </td>
                            </tr>
                            <tr>
                                <th>수금메모(세금계산서 비고)</th>
                                <td colSpan={3}>
                                    {data?.newTxtCollection}
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        // ===== 수정 화면 =====
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>담당자</th>
                                <td style={{ width: "33.34%" }} className="p-4px">
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("contactPersonName")}
                                            disabled
                                        />
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() =>
                                                handleModal({
                                                    isOpen: true,
                                                    contents: (
                                                        <SearchSystemUserInner
                                                            confirmCallback={(item) => {
                                                                if (setValue) {
                                                                    setValue("contactPerson", item?.systemuserid);
                                                                    setValue("contactPersonName", item?.fullname);
                                                                }
                                                            }}
                                                            modalDepth={1}
                                                        />
                                                    ),
                                                    type: "",
                                                    title: "사용자 조회",
                                                    modalSize: "xl",
                                                })
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/icon_search.png"
                                                }
                                                alt=""
                                            />
                                            찾기
                                        </button>
                                    </div>
                                </td>
                                <th style={{ width: "16.66%" }}>
                                    수주유형 <span className="required">*</span>
                                </th>
                                <td className="p-4px">
                                    <select className="form-select" {...register("orderType")}>
                                        {orderTypeSelect?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    납품처 <span className="required">*</span>
                                </th>
                                <td className="p-4px">
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("deliveryPlaceName")}
                                            disabled
                                        />
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() =>
                                                handleModal({
                                                    isOpen: true,
                                                    contents: (
                                                        <SearchErpInner
                                                            confirmCallback={(item) => {
                                                                console.log(item);
                                                                if (setValue) {
                                                                    setValue("deliveryPlace", item?.new_erp_accountid as string);
                                                                    setValue("deliveryPlaceName", item.new_txt_nm_partner as string);
                                                                }
                                                            }}
                                                            modalDepth={1}
                                                        />
                                                    ),
                                                    type: "",
                                                    title: "납품처 조회",
                                                    modalSize: "xl",
                                                })
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/icon_search.png"
                                                }
                                                alt=""
                                            />
                                            찾기
                                        </button>
                                    </div>
                                </td>
                                <th>산업구분</th>
                                <td className="p-4px">
                                    <select
                                        className="form-select"
                                        {...register("industryCategory")}
                                    >
                                        {industrySelect?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    매출처 <span className="required">*</span>
                                </th>
                                <td className="p-4px">
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("salesPlaceName")}
                                            disabled
                                        />
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() =>
                                                handleModal({
                                                    isOpen: true,
                                                    contents: (
                                                        <SearchErpInner
                                                            confirmCallback={(item) => {
                                                                if (setValue) {
                                                                    setValue("salesPlace", item?.new_erp_accountid as string);
                                                                    setValue("salesPlaceName", item?.new_txt_nm_partner as string);
                                                                }
                                                            }}
                                                            modalDepth={1}
                                                        />
                                                    ),
                                                    type: "",
                                                    title: "매출처 조회",
                                                    modalSize: "xl",
                                                })
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/icon_search.png"
                                                }
                                                alt=""
                                            />
                                            찾기
                                        </button>
                                    </div>
                                </td>
                                <th>Application</th>
                                <td className="p-4px">
                                    <select className="form-select" {...register("application")}>
                                        {applicationSelect?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>세금계산서 담당자</th>
                                <td className="p-4px">
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("taxChargeName")}
                                            disabled
                                        />
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() =>
                                                handleModal({
                                                    isOpen: true,
                                                    contents: (
                                                        <SearchContactsInner
                                                            confirmCallback={(item) => {
                                                                if (setValue) {
                                                                    setValue(
                                                                        "taxInvoicePerson",
                                                                        item?.contactId
                                                                    );
                                                                    setValue("taxChargeName", item?.fullName);
                                                                }
                                                            }}
                                                            modalDepth={1}
                                                        />
                                                    ),
                                                    type: "",
                                                    title: "사용자 조회",
                                                    modalSize: "xxl",
                                                })
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/icon_search.png"
                                                }
                                                alt=""
                                            />
                                            찾기
                                        </button>
                                    </div>
                                </td>
                                <th>
                                    Vat 구분 <span className="required">*</span>
                                </th>
                                <td className="p-4px">
                                    <select className="form-select" {...register("vatType")}>
                                        {vatSelect?.map((item) => {
                                            return <option value={item?.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>환율 기준일</th>
                                <td className="p-4px">
                                    <select
                                        className="form-select"
                                        {...register("exchangeRateCondition1")}
                                    >
                                        <option value={undefined} hidden>선택</option>
                                        {exchangeTypeSelect1?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                                <th>환율 지정 조건</th>
                                <td className="p-4px">
                                    <div className="d-flex align-items-center">
                                        <select
                                            className="form-select"
                                            {...register("exchangeRateCondition2")}
                                        >
                                            <option value={undefined} hidden>선택</option>
                                            {exchangeTypeSelect2?.map((item) => {
                                                return <option value={item.id}>{item?.name}</option>;
                                            })}
                                        </select>
                                        <select
                                            className="form-select ms-1"
                                            {...register("exchangeRateCondition3")}
                                        >
                                            <option value={undefined} hidden>선택</option>
                                            {exchangeTypeSelect3?.map((item) => {
                                                return <option value={item.id}>{item?.name}</option>;
                                            })}
                                        </select>
                                        <select
                                            className="form-select ms-1"
                                            {...register("exchangeRateUnit")}
                                        >
                                            <option value={undefined} hidden>선택</option>
                                            {exchangeRateUnitSelect?.map((item) => {
                                                return <option value={item.id}>{item?.name}</option>;
                                            })}
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>원화 단가 단위</th>
                                <td className="p-4px">
                                        <select className="form-select" {...register("wonUnit")} disabled={user?.authority?.orderWriteYn === 'N'}>
                                        <option value={undefined} hidden>선택</option>
                                        {wonUnitSelect?.map((item) => {
                                            return <option value={item.id}>{item?.name}</option>;
                                        })}
                                    </select>
                                </td>
                                <th>마감 구분</th>
                                <td className="p-4px">
                                    <select className="form-select"
                                        {...register("endType")}>
                                        <option value={""} hidden>선택</option>
                                        <option value={"1"}>일반</option>
                                        <option value={"2"}>월마감</option>
                                        <option value={"3"}>역발행</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>기타사항(거래명세서 비고)</th>
                                <td className="p-4px" colSpan={3}>
                                    <input className="form-control" {...register("newTxtNote")} />
                                </td>
                            </tr>
                            <tr>
                                <th>수금메모(세금계산서 비고)</th>
                                <td className="p-4px" colSpan={3}>
                                    <input className="form-control" {...register("newTxtCollection")} />
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>

            <div className="table_scroll mb-0 mt-3">
                <table className="table table-bordered my_table table_detail">
                    {mode === "R" ? (
                        // ===== 조회 화면 =====
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>수신자</th>
                                <td style={{ width: "33.34%" }}>{data?.recipientName}</td>
                                <th style={{ width: "16.66%" }}>발송지 주소</th>
                                <td>{data?.addressName}</td>
                            </tr>
                            {/*<tr>*/}
                            {/*    <th>주소1</th>*/}
                            {/*    <td>{data?.address1}</td>*/}
                            {/*    <th>주소2</th>*/}
                            {/*    <td>{data?.address2}</td>*/}
                            {/*</tr>*/}
                            <tr>
                                <th>메모</th>
                                <td colSpan={3}>{data?.memo}</td>
                            </tr>
                        </tbody>
                    ) : (
                        // ===== 수정 화면 =====
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>수신자</th>
                                <td style={{ width: "33.34%" }} className="p-4px">
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("recipientName")}
                                            disabled
                                        />
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() =>
                                                handleModal({
                                                    isOpen: true,
                                                    contents: (
                                                        <SearchContactsInner
                                                            confirmCallback={(item) => {
                                                                if (setValue) {
                                                                    setValue("recipient", item?.contactId);
                                                                    setValue("recipientName", item?.fullName);
                                                                }
                                                            }}
                                                            modalDepth={1}
                                                        />
                                                    ),
                                                    type: "",
                                                    title: "연락처 조회",
                                                    modalSize: "xxl",
                                                })
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/icon_search.png"
                                                }
                                                alt=""
                                            />
                                            찾기
                                        </button>
                                    </div>
                                </td>
                                <th style={{ width: "16.66%" }}>발송지 주소</th>
                                {/*
                                const {handleModal, resetModal} = useModal();
                            */}
                                <td className="p-4px">
                                    <div className="d-flex">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("addressName")}
                                            disabled
                                        />
                                        <button
                                            className="btn btn-info btn_search ms-5px"
                                            onClick={() =>
                                                handleModal({
                                                    isOpen: true,
                                                    contents: (
                                                        <SearchAddressInner
                                                            confirmCallback={(item) => {
                                                                if (setValue) {
                                                                    setValue(
                                                                        "shippingAddress",
                                                                        item?.new_addressid
                                                                    );
                                                                    setValue("addressName", item?.newName);
                                                                    setValue("address1", item?.new_txt_line1);
                                                                    setValue("address2", item?.new_txt_line2);
                                                                }
                                                            }}
                                                            modalDepth={1}
                                                        />
                                                    ),
                                                    type: "",
                                                    title: "주소 조회",
                                                    modalSize: "xxl",
                                                })
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/icon_search.png"
                                                }
                                                alt=""
                                            />
                                            찾기
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            {/*<tr>*/}
                            {/*    <th>주소1</th>*/}
                            {/*    <td>{watchShipmentInfo?.address1}</td>*/}
                            {/*    <th>주소2</th>*/}
                            {/*    <td>{watchShipmentInfo?.address2}</td>*/}
                            {/*</tr>*/}
                            <tr>
                                <th>메모</th>
                                <td colSpan={3} className="p-4px">
                                    <input className="form-control" {...register("memo")} />
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
};
